import React from "react";

export function Header() {
  return <header className="site-header wrap">
    <a className="brand" href="/" aria-label="Focus Cards home"><span className="brand-mark" aria-hidden="true">f</span>Focus Cards</a>
    <nav aria-label="Main navigation"><a href="/#activities">Free activities</a><a href="/#plus">Focus Cards Plus</a><a href="/support">Support</a></nav>
  </header>;
}

export function Footer() {
  return <footer className="site-footer wrap">
    <div><a className="brand" href="/">Focus Cards</a><p>Focus, learn, and play.</p></div>
    <nav aria-label="Footer navigation"><a href="/privacy-policy">Privacy Policy</a><a href="/focus-cards-plus-terms">Plus subscription terms</a><a href="/support">Contact &amp; support</a></nav>
  </footer>;
}

